module.exports = __webpack_public_path__ + "static/media/ni.7affd52e.svg";